<template>
<div>
  <div v-if="!success" class="qaFeedback container">
    <Header v-show="!show" title="销售方质保信息"  :leftHandler="leftHandler"></Header>

    <div class="info">
      <div class="info-item">
        <div class="title">博世料号：</div>
        <div class="text">{{codeInfo.partNo}}</div>
      </div>

      <div class="info-item">
        <div class="title">保单状态：</div>
        <div class="text">{{getItemStatus(codeInfo.warrantyStatus)}}</div>
      </div>

      <div class="info-item" v-if="codeInfo.warrantyStatus===4">
        <div class="title">审批状态：</div>
        <div class="text">{{codeInfo.verifyStatus}}</div>
      </div>

      <div class="info-item" v-if="codeInfo.verifySign&&codeInfo.verifySign!=='01'">
        <div class="title">审批备注：</div>
        <div class="text">{{codeInfo.warrantyHistory[0].verifyRemark}}</div>
      </div>

      <div class="info-item">
        <div class="title">质保单号：</div>
        <div class="text">{{codeInfo.warrantyCode}}</div>
      </div>
      <div class="info-item">
        <div class="title">产品名称：</div>
        <div class="text">{{codeInfo.partName}}</div>
      </div>
      <div class="info-item" v-if="codeInfo.carName">
        <div class="title">车型：</div>
        <div class="text">{{codeInfo.carName}}</div>
      </div>
      <div class="info-item" v-if="codeInfo.consumerMobile">
        <div class="title">车主手机号：</div>
        <div class="text">{{codeInfo.consumerMobile}}</div>
      </div>
      <div class="info-item">
        <div class="title">安装时里程数：</div>
        <div class="text">{{codeInfo.initMileage}}&nbsp;KM</div>
      </div>
      <div class="info-item">
        <div class="title">销售方名称：</div>
        <div class="text">{{codeInfo.workshopName}}</div>
      </div>
      <div class="info-item">
        <div class="title">销售方地址：</div>
        <div class="text">{{codeInfo.workshopAddress}}</div>
      </div>
      <div class="info-item">
        <div class="title">安装时间：</div>
        <div class="text">{{codeInfo.initTime?parseTime(codeInfo.initTime,'{y}-{m}-{d}'):''}}</div>
      </div>
      <div class="info-item" v-if="codeInfo.endTime">
        <div class="title">质保截至：</div>
        <div class="text">{{codeInfo.endTime?parseTime(codeInfo.endTime,'{y}-{m}-{d}'):''}}或者里程数到{{getFinalMileage()}}公里，以先到为准</div>
      </div>
      <div class="info-item">
        <div class="title">门店安装人员：</div>
        <div class="text">{{codeInfo.workshopPerson}}</div>
      </div>
      <div class="info-item">
          <div class="title">提交人员：</div>
          <div class="text">{{codeInfo.userName || ''}}</div>
        </div>
    </div>

    <div v-if="codeInfo.warrantyStatus===4">
      <div class="info">

        <div class="info-item">
          <div class="title">当前里程数：</div>
          <div class="text">{{codeInfo.warrantyHistory[0].reportMileage || ''}}&nbsp;KM</div>
        </div>
        <div class="info-item">
          <div class="title">故障描述及判断：</div>
        </div>
        <div class="info-item">
          <div>{{codeInfo.warrantyHistory[0].warrantyDesc || ''}}</div>
        </div>
        <div class="info-item">
          <div class="title">照片：</div>
        </div>
        <div class="info-item img-list">
          <div v-for="(item,index) of codeInfo.warrantyHistory[0].mediaList" :key="item.mediaId+index">
            <img @click="showImg(item.imageUrl,'image')" :src="item.imageUrl">
            <!-- <img v-if="getUrlType(item.imageUrl)==='video'" @click="showImg(item.imageUrl,'video')" src="https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/img/warranty/replacement.png"> -->
            <!-- <video autoplay class="video" v-if="getUrlType(item.imageUrl)==='video'" :src="item.imageUrl"  @click="showImg(item.imageUrl,'video')"></video> -->
          </div>
        </div>
      </div>
      <div class="block-1"></div>
      <!-- <div class="footer" v-if="!codeInfo.existUnite&&codeInfo.warrantyStatus!==5">
        <div class="btn submit-btn" @click="qaUnbound()">不质保并解绑</div>
      </div> -->
    </div>

    <div class="footer" v-if="codeInfo.warrantyStatus===4&&relationWarrantyId===''">
      <div v-if="codeInfo.verifySign&&codeInfo.verifySign==='04'" class="btn submit-btn" @click="gotoweb(false,'resubmission')">重新提交</div>
      <div class="btn submit-btn" v-if="codeInfo.verifySign!=='03'" @click="gotoweb(false,'submitCode')">关联新电瓶</div>
    </div>

    <div class="footer" v-if="codeInfo.warrantyStatus===4&&relationWarrantyId!==''">
      <div v-if="codeInfo.verifySign&&codeInfo.verifySign==='04'" class="btn submit-btn" @click="gotoweb(false,'resubmission')">重新提交</div>
      <div class="btn submit-btn" @click="gotoweb(true)">查看换货后的保单</div>
    </div>

    <div class="footer" v-if="codeInfo.warrantyStatus===1||codeInfo.warrantyStatus===3">
      <div class="btn submit-btn color-red" @click="qaUnbound()" >不质保并解绑</div>
      <div class="btn submit-btn" @click="gotoweb(false,'submit')">提交质保</div>
      <div class="btn submit-btn" v-if="codeInfo.warrantyStatus===1" @click="gotoweb(false,'update')">重新编辑</div>
    </div>

    <!-- <div class="footer" v-if="codeInfo.warrantyStatus===6">
      <div class="btn submit-btn" @click="gotoweb(true)">查看换货后的保单</div>
    </div> -->

    <van-overlay :show="show" @click="show = false">
      <div class="wrapper" >
        <div class="img-block">
          <!-- <div  v-if="urlType==='image'" :style="'background-image: url('+url+');'" class="block-img">
          </div> -->
          <img v-if="urlType==='image'"   :src="url">
          <video autoplay class="video" v-if="urlType==='video'" :src="url" controls></video>

        </div>
          <img v-if="urlType==='video'"
            @click="show=false"
            class="video-delete"
            src="../../../assets/images/activity/form-verification-off.png"
          >
      </div>

    </van-overlay>

  </div>

  <div v-else class="success">
    <Header title="提交成功"></Header>

    <div class="result-info">
      <img src="../../../assets/images/activity/form-verification-right.png" alt="">
      <div class="result-info-text"> 提交成功</div>
    </div>

    <div class="footer">
      <div class="btn submit-btn" @click="back()">返回</div>
    </div>
  </div>
</div>

</template>

<script>
import Header from '../../../components/header.vue'
import { commonUtils } from '@/utils/common'
import activityApi from '@/api/activity'
export default {
  components: { Header },
  data () {
    return {
      value: '',
      code: '',
      codeInfo: {},
      warrantyId: '',
      data: {
        reportMileage: '',
        warrantyDesc: '',
        mediaFileIds: '',
        warrantyId: '',
        partQrCode: '',
        warrantyCode: '',
        consumerMobile: ''
      },
      fileList: [],
      fileId: [],
      fileUri: [],
      success: false,
      show: false,
      url: '',
      urlType: '',
      videourl: '',
      allInfoList: [],
      isUploading: false,
      imgList1: [],
      imgList2: [],
      imgList3: [],
      isReplace: '',
      exchangeInfo: {},
      partQrCode: '',
      relationWarrantyId: ''
    }
  },
  watch: {
    'allInfoList' () {
      this.imgList = []
      for (let item of this.allInfoList) {
        let data = {
          type: item.type,
          name: item.originalName,
          url: item.type === 'video' ? 'https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/img/warranty/replacement.png' : commonUtils.getImageUrl(item.fileUri) // 'https://img.bosch-extra.com.cn:8443/public-tmp/8A/e11fc31e-2496-45f3-ad7d-9e415c953a3d.jpg' // 'https://img.bosch-extra.com.cn:8443/' + item.fileList
        }
        this.imgList.push(data)
        console.log(this.imgList)
      }
    }
  },
  created () {
    commonUtils.configWxJsSdk().catch(error => {
      this.$emit('error', { errorMsg: error })
    })
    this.warrantyId = this.$route.query.warrantyId
    this.init()
  },
  mounted () {
    const u = navigator.userAgent
    const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    console.log('isIOS', isIOS)
    if (isIOS && location.href.indexOf('#reloaded') === -1) {
      location.href = location.href + '#reloaded'
      location.reload()
    }
  },
  methods: {
    parseTime: commonUtils.parseTime,
    init () {
      let params = {
        warrantyId: this.warrantyId
      }
      activityApi.getQaFeedbackInfo(params).then(res => {
        if (res.data.resultCode === '0') {
          this.codeInfo = res.data.resultData.warrantyInfo
          this.relationWarrantyId = this.codeInfo.relationWarrantyId || ''
        }
      })
    },
    leftHandler () {
      if (this.$route.query.scanAdd) {
        this.$router.push({ name: 'gbb-qrCode-scan' })
      } else {
        this.$router.go(-1)
      }
    },
    validatorKM (val) {
      let reg = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g
      if ((reg.test(val) && Number(val) >= 0)) return true
      return false
    },
    validatorMobile (val) {
      let reg = /^(1[3|4|5|6|7|8|9][0-9]\d{8})$/
      if (reg.test(val)) return true
      return false
    },
    handleInitMileage () {
      let distance = Number(this.data.reportMileage).toFixed(2)
      console.log(typeof this.data.reportMileage)
      this.data.reportMileage = distance
    },
    gotoweb (isReplace, type) {
      if (isReplace) {
        this.warrantyId = this.relationWarrantyId
        this.data = {
          reportMileage: '',
          warrantyDesc: '',
          mediaFileIds: '',
          warrantyId: '',
          partQrCode: '',
          warrantyCode: ''
        }
        this.fileId = []
        this.fileUri = []
        this.imgList1 = []
        this.imgList2 = []
        this.imgList3 = []
        this.allInfoList = []
        this.relationWarrantyId = ''
        this.exchangeInfo = {}
        this.init()
      } else {
        if (type === 'submit') {
          this.$router.push({ name: 'quality-assurance-ws-feedback-detail', query: { warrantyId: this.warrantyId, type: 'info' } })
        } else if (type === 'update') {
          let data = JSON.stringify(this.codeInfo)
          sessionStorage.setItem('codeInfo', data)
          this.$router.push({ name: 'quality-assurance-ws-info' })
        } else if (type === 'submitCode') {
          this.$router.push({ name: 'quality-assurance-ws-feedback-detail', query: { warrantyId: this.warrantyId, type: 'info', submitType: 'code' } })
        } else if (type === 'resubmission') {
          this.$router.push({ name: 'quality-assurance-ws-feedback-detail', query: { warrantyId: this.warrantyId, submitType: 'resubmission' } })
        }
      }
    },
    getFinalMileage () {
      return Number(this.codeInfo.endMileage)
    },
    getUrlType (url) {
      let data = url.split('.')
      let imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif']
      let videolist = ['mp4', 'm2v', 'mkv']
      let type = data[data.length - 1]
      if (imglist.indexOf(type) !== -1) {
        return 'image'
      } else if (videolist.indexOf(type) !== -1) {
        return 'video'
      }
    },
    getItemStatus (status) {
      switch (status) {
        case 1:
          return '销售方激活'
        case 2:
          return '车主未领取'
        case 3:
          return '车主已领取'
        case 4:
          return '质保已提交'
        case 5:
          return '已失效'
        default:
          break
      }
    },
    showImg (url, type, isSample) {
      if (isSample) {
        this.url = this.$getImgUrl(url)
      } else {
        this.url = url
      }
      this.urlType = type
      this.show = true
    },
    back () {
      this.success = false
      this.init()
    },
    getUrl (uri) {
      return commonUtils.getImageUrl(uri)
    },
    qaUnbound () {
      this.$dialog.confirm({
        title: '操作提示',
        message: '该操作会导致车主提交质保无效，是否确定不质保并解除绑定？'
      })
        .then(() => {
          let data = {
            warrantyId: this.warrantyId
          }
          activityApi.qaUnbound(data).then(res => {
            if (res.data.resultCode === '0') {
              this.$dialog.alert({
                message: '解绑成功！'
              })
              this.init()
            } else {
              this.$notify({
                background: '#1989fa',
                message: res.data.resultMsg,
                className: 'notify-error-msg'
              })
            }
          })
        }).catch(() => {
        })
    },

    submitQAInfo () {
      this.isReplace = ''
    }
  }
}
</script>

<style lang="less" scoped>
// @media (max-height: 450px){
//   .footer {
//     position: static !important;
//   }
// }
.block-1{
  width: 100%;
  height: 50px;
}
.block-2{
  width: 100%;
  height: 80px;
}
.block-img{
  width: 100vw;
  height: 100vh;
  z-index: 200;
  position: absolute;
  top: 0;
  z-index: 200;
}
.container{
  position: relative;
  top: 46px;
}
.result-info{
  text-align: center;
  padding: 90px 0 20px 0;
  img{
    width: 80px;
  }
  .result-info-text{
    padding: 25px 0 5px 0;
    font-size: 16px;
  }
}
.info{
  position: relative;
  padding: 10px 0;
 // margin: 20px;
  margin: 0 5px;
  background-color: white;
  border-radius: 5px;
}
.btn{
  width: 100%;
  text-align: center;
  border-radius: 3px;
  color: white;
  background-color: rgb(17, 114, 129);
}
.submit-btn{
  margin: 10px;
  padding: 10px 8px;
}
.exchang-btn{
  width: 30px;
  padding: 5px 10px;
}
.footer{
  width: 100vw;
  background-color: white;
  position: fixed;
  bottom: 0px;
  display: flex;
  justify-content: space-evenly;
}
.info-item{
  display: flex;
  .title{
    min-width: 100px;
    word-break: keep-all;
    color: gray;
  }
  .title-sp{
    color: black;
  }
  .text-sp{
    font-size: 20px;
  }
  word-break:break-all;
}
.input-info{
  top: 10px;
  position: relative;
  padding: 10px;
 // margin: 20px;
  margin: 0 5px;
  background-color: rgb(255, 255, 255) !important;
  border-radius: 5px;
  .van-field__label{
    color: red;
  }
}
.info-item{
  margin: 15px 25px;
  display: flex;
  justify-content: space-between;
  .title{
    color: gray;
  }
}
.score-field .van-field {
  background: #f1f1f1;
  border-radius: 3px;
}
.input-textarea .van-cell{
  background: #f8f8f8;
}
.input-title{
  margin: 15px 17px;
  color: rgb(22, 22, 22);
  display: flex;
  justify-content: space-between;
}
.input-example{
  color: rgb(28, 154, 212);
  font-size: 12px;
}
.input-upload{
  margin: 0 12px;
}
.img-list{
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  img{
    width: 24vw;
    height: 24vw;
    object-fit: cover;
    padding: 5px;
  }
  video{
    width: 24vw;
    height: 24vw;
    margin-right: 10px;
    padding: 5px;
  }
}

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .img-block {
    position: relative;
    img{
      z-index: 99;
      width: 100vw;
      height: auto;
      object-fit: cover;
    }
    video{
      width: 100%;
      max-height: 100vh;
    }
  }
  .video-delete{
    width: 45px;
    position: absolute;
    top: 60px;
    left: calc(100vw - 60px);
  }
  .loading{
    height: 14px;
    display: inline-block;
  }
  .video-cover{
  width: 25vw;
  height: 25vw;
  background-color: black;
}
.cover-img{
  width: 10vw;
  height: 10vw;
  padding: 7.5vw;
  background-color: black;
}
.margin-top-10{
  margin-top: 10px;
}
.margin-left-25{
  margin-left: 25px;
}
.color-red{
  background-color: rgb(235, 8, 8);
}
.margin-top-20 {
  margin-top:20px;
}
.loading{
  position: absolute;
  top: 40%;
  left: calc(50vw - 17.5px);
  z-index:10;
}
</style>
